var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1565 3.5V9.1875C11.1565 9.36155 11.0873 9.52847 10.9643 9.65154C10.8412 9.77461 10.6743 9.84375 10.5002 9.84375C10.3262 9.84375 10.1593 9.77461 10.0362 9.65154C9.91311 9.52847 9.84397 9.36155 9.84397 9.1875V5.08594L3.96452 10.9643C3.84123 11.0876 3.67402 11.1568 3.49967 11.1568C3.32532 11.1568 3.15811 11.0876 3.03483 10.9643C2.91155 10.841 2.84229 10.6738 2.84229 10.4995C2.84229 10.3251 2.91155 10.1579 3.03483 10.0346L8.91428 4.15625H4.81272C4.63867 4.15625 4.47175 4.08711 4.34868 3.96404C4.22561 3.84097 4.15647 3.67405 4.15647 3.5C4.15647 3.32595 4.22561 3.15903 4.34868 3.03596C4.47175 2.91289 4.63867 2.84375 4.81272 2.84375H10.5002C10.6743 2.84375 10.8412 2.91289 10.9643 3.03596C11.0873 3.15903 11.1565 3.32595 11.1565 3.5Z",
    fill: "#F1E1D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.1f1e506c1e1b8c6a07e33682b68aaba9.svg";
export { ForwardRef as ReactComponent };